export default {
    orbia: {
        button: 'Conversar',
        title: 'O Orbia chegou!',
        text: 'Tire dúvidas sobre seu mapa astral com o nosso assistente, gratuitamente!',
    },
    profileFamous: {
        button: 'Acessar',
        title: 'Novidade',
        text: 'Acesse o Mapa Astral dos famosos e descubra sua Compatibilidade Astral com eles!',
        label: 'Veja os perfis disponíveis'
    },
}